import {
  resetPassword,
  usePasswordValidation,
  useResetPassword,
} from '@auth0/auth0-acul-react/reset-password';

import { executeSafely } from '@/utils/helpers/executeSafely';

/**
 * Handles the password reset process
 *
 * @param password - Current password value for validation
 * @returns Password validation result and reset handler
 */
export const useResetPasswordManager = (password: string = '') => {
  const handleResetPassword = async (new_password: string): Promise<void> => {
    const options: { 'password-reset': string; 're-enter-password': string } = {
      'password-reset': new_password?.trim() || '',
      're-enter-password': new_password?.trim() || '',
    };
    executeSafely(
      `Submit password reset with options: ${JSON.stringify(options)}`,
      () => resetPassword(options),
    );
  };

  const passwordValidation = usePasswordValidation(password, {
    includeInErrors: true,
  });

  return {
    resetPassword: useResetPassword(),
    handleResetPassword,
    passwordValidation,
  };
};
